import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChPoolService {

  constructor() { }

  private pool={};
  public savedData = {}

  public GetChannel(key:string) {
    if(this.pool[key]){
      return this.pool[key];
    }
    return this.SetThenGetChannel(key);

  }

  public SetThenGetChannel(key:string,defaultValue :any =null) {
    if(this.pool[key]){
      return this.pool[key];
    }

    this.pool = Object.assign(this.pool,{[key.toString()]:new BehaviorSubject<any>(defaultValue)});
    return this.pool[key];
  }


}
